
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component
export default class BlueButton extends Vue {
  @Prop() private icon!: string
  @Prop() private text!: string
  @Prop() private readonly disabled!: boolean
  @Prop() private readonly loading!: boolean
  @Prop() private iconSize?: number
}
